import React from "react";
import { Link } from "react-router-dom";

const STEPS = [
  { title: "Démo orientée métier", desc: "Parcours opportunité → shortlist → CV client.", num: "01" },
  { title: "Audit de vos irritants", desc: "CV, staffing, compétences, partenaires, suivi commercial.", num: "02" },
  { title: "Projection d'usage", desc: "Comment l'équipe commerce, RH et direction peut l'adopter.", num: "03" },
  { title: "Déploiement progressif", desc: "Une logique modulaire, adaptée à votre organisation.", num: "04" },
];

const FinalCta = () => (
  <section className="mk-final" id="demo" data-testid="section-final-cta">
    <div className="mk-wrap mk-demo">
      <div className="mk-cta-panel mk-reveal">
        <h2>Transformez votre société à la vitesse de l'IA</h2>
        <p>Réservez une démo personnalisée, on regarde ensemble comment ASAP Hub peut s'adapter à votre quotidien.</p>
        <div>
          <Link to="/contact" className="mk-btn mk-btn-primary" data-testid="final-cta-button">
            Demander une démo
          </Link>
        </div>
      </div>
      <div className="mk-module-list mk-reveal">
        {STEPS.map((step) => (
          <div key={step.num} className="mk-module">
            <span>
              <b>{step.title}</b>
              <span>{step.desc}</span>
            </span>
            <i>{step.num}</i>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FinalCta;
